export const parseAddressWithoutRegion = (adrAddress: string): string => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(`<div>${adrAddress}</div>`, "text/html");

    const streetAddress = doc.querySelector('[class*="street-address"]');
    const extendedAddress = doc.querySelector('[class*="extended-address"]');
    const locality = doc.querySelector('[class*="locality"]');
    const postalCode = doc.querySelector('[class*="postal-code"]');
    const countryName = doc.querySelector('[class*="country-name"]');

    let address = "";

    if (streetAddress) {
        address += streetAddress.textContent;
    }

    if (extendedAddress) {
        address += `, ${extendedAddress.textContent}`;
    }

    if (!extendedAddress && locality) {
        address += `, ${locality.textContent}`;
    }

    if (postalCode) {
        address = address.replace(postalCode.textContent, "").trim();
    }

    if (countryName) {
        address = address.replace(countryName.textContent, "").trim();
    }

    return address;
};
